import { AlertTriangle } from 'lucide-react';
import { Badge } from '@/app/components/ui/badge';
import type { TechCertStatus } from '@/lib/types';

interface CertificationStatus {
  status: TechCertStatus;
}

function getCertificationHealth(
  certifications: CertificationStatus[] | undefined,
): 'expired' | 'revoked' | 'expiring_soon' | null {
  if (certifications?.some((certification) => certification.status === 'expired')) {
    return 'expired';
  }
  if (certifications?.some((certification) => certification.status === 'revoked')) {
    return 'revoked';
  }
  if (certifications?.some((certification) => certification.status === 'expiring_soon')) {
    return 'expiring_soon';
  }
  return null;
}

export function CertificationHealthBadge({
  certifications,
  compact = false,
}: {
  certifications: CertificationStatus[] | undefined;
  compact?: boolean;
}) {
  const health = getCertificationHealth(certifications);
  if (!health) return null;

  const styles = {
    expired: 'bg-red-100 text-red-800 hover:bg-red-100',
    revoked: 'bg-gray-200 text-gray-800 hover:bg-gray-200',
    expiring_soon: 'bg-amber-100 text-amber-800 hover:bg-amber-100',
  };
  const labels = {
    expired: compact ? 'Cert: Expired' : 'Certification: Expired',
    revoked: compact ? 'Cert: Revoked' : 'Certification: Revoked',
    expiring_soon: compact ? 'Cert: Expiring Soon' : 'Certification: Expiring Soon',
  };

  return (
    <Badge className={styles[health]}>
      <AlertTriangle className="mr-1 h-3 w-3" />
      {labels[health]}
    </Badge>
  );
}
